import type { ReactNode } from 'react';
import { Link } from 'react-router';

export const Section = ({ title, children }: { title: ReactNode; children: ReactNode }) => (
  <section className="rounded-xl border border-gray-200 bg-white">
    <header className="border-b border-gray-100 px-5 py-3">
      <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
    </header>
    <div className="p-5">{children}</div>
  </section>
);

export const KeyValueGrid = ({ items }: { items: { label: string; value: ReactNode }[] }) => (
  <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
    {items.map((it) => (
      <div key={it.label}>
        <dt className="text-xs text-gray-400">{it.label}</dt>
        <dd className="mt-0.5 text-sm text-gray-900">{it.value}</dd>
      </div>
    ))}
  </dl>
);

export const DetailHeader = ({
  backTo,
  backLabel,
  title,
  badges,
}: {
  backTo: string;
  backLabel: string;
  title: ReactNode;
  badges?: ReactNode;
}) => (
  <div className="flex flex-col gap-3">
    <Link to={backTo} className="text-xs text-gray-500 hover:text-gray-900 transition-colors">
      ← {backLabel}
    </Link>
    <div className="flex items-center gap-3">
      <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
      {badges}
    </div>
  </div>
);
